$(function(){
	$('.datepickerstart').datepicker({
		format: 'M-yyyy',
		minViewMode: "months",
		changeMonth: true,
		changeYear: true,
	    startDate: '+1d',
		showOn: 'focus',
        showButtonPanel: true,
	    // beforeShowDay: '+20d',
	    autoclose: true,
		closeText: 'Clear', // Text to show for "close" button
        onClose: function () {
			var event = arguments.callee.caller.caller.arguments[0];
			// If "Clear" gets clicked, then really clear it
			if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
				$(this).val('');
			}
		}
	}).on('changeDate', function (selected) {
	    var startDate = new Date(selected.date.valueOf());
	    $('.datepickerend').datepicker('setStartDate', startDate);
	});

	$('.datepickerend').datepicker({
		format: 'mm-yyyy',
		minViewMode: "months",
		changeMonth: true,
		changeYear: true,
	    startDate: '+2d',
	    autoclose: true,
		dateFormat: "MM"
	}).on('changeDate', function (selected) {
	    var endDate = new Date(selected.date.valueOf());
	    $('.datepickerstart').datepicker('setEndDate', endDate);
	});

	$('#togglesearch').click(function() {
		$('#search').slideToggle(400);
		ga('send', 'event', 'Search icon', 'clicked');
	});

    $('.js-search-btn').click(function(){
        ga('send', 'event', 'Search btn', 'clicked');
    })

})		